<template>
    <div>
        <div class="process-header">
            <div>
                <img v-if="$store.state.user.logoPath" :src="$store.state.apiUrl + $store.state.spacesUrl + $store.state.user.logoPath" />
            </div>
            <div class="ps-meta">
                <!-- Long lists cut off with "..."; hover shows the full list, click toggles it open -->
                <div v-if="$store.state.user.isAdmin" :class="['ps-meta-clip', { open: expanded.location }]" :title="locationString" @click="expanded.location = !expanded.location"><span class="lbl">Location</span>: {{ locationString }}</div>
                <div v-if="$store.state.user.isAdmin && prevNodes.length">
                    <span class="lbl">Linked From</span>:
                    <span v-for="(prevNode, i) in prevNodes" :key="i">
                        &nbsp;<a :href="'/playbook/' + prevNode.ThisSlug" :target="linkTarget">{{ prevNode.Name }}</a><br/>
                    </span>
                </div>
                <div v-if="departmentsString" :class="['ps-meta-clip', { open: expanded.departments }]" :title="departmentsString" @click="expanded.departments = !expanded.departments"><span class="lbl">Department</span>: {{ departmentsString }}</div>
                <div v-if="nodeTypesString" :class="['ps-meta-clip', { open: expanded.types }]" :title="nodeTypesString" @click="expanded.types = !expanded.types"><span class="lbl">Type</span>: {{ nodeTypesString }}</div>
                <div v-if="lastModified"><span class="lbl">Last Modified</span>: {{ lastModified }} V{{ node.Version }}</div>
                <div v-if="$store.state.user.isAdmin && node.LastUpdatedBy"><span class="lbl">Last Modified By</span>: {{ node.LastUpdatedBy }}</div>
                <div v-if="lastReviewed"><span class="lbl">Last Reviewed</span>: {{ lastReviewed }}</div>
                <div v-if="$store.state.user.isAdmin && node.LastReviewedBy"><span class="lbl">Last Reviewed By</span>: {{ node.LastReviewedBy }}</div>
                <div v-if="files.length">
                    <span class="lbl">Files</span>:
                    <span v-for="(file, i) in files" :key="i">
                        <a :href="$store.state.apiUrl + $store.state.spacesUrl + file.SpacesPath" target="_blank">{{ file.Name }}</a><span v-if="i < files.length - 1">, </span>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'ProcessHeader',
    props: [ 'node', 'locationString', 'departmentsString', 'nodeTypesString', 'lastModified', 'lastReviewed', 'prevNodes', 'files', 'linkTarget' ],
    data() {
        return {
            expanded: { location: false, departments: false, types: false }
        }
    }
});
</script>
